import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataTransferService } from '../../services/DataTransferService';
import { GlobalService } from '../../services/global.service';
import { TableService } from '../../services/table.service';
import { UserService } from '../../services/usre.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-branch-selection',
  templateUrl: './branch-selection.component.html',
  styleUrls: ['./branch-selection.component.scss']
})
export class BranchSelectionComponent implements OnInit {

  @Output() branchObj = new EventEmitter();
  @Output() branchSelectionAction = new EventEmitter();
  isBranch: boolean;
  navStart: Observable<NavigationStart>;
  company = null;
  constructor(
    private user: UserService,
    private userContext: TableService,
    private router: Router,
    private globalSrv: GlobalService,
    private dataTransfer: DataTransferService,
    private translate: TranslateService) {
    this.isBranch = this.router.url != '/dashboard/outlet-selection'
    this.navStart = router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
    this.branchSelectionAction.emit(false);
    this.dataTransfer.currentCompany.subscribe((x) => {

      this.company = x;

      sessionStorage.setItem("company", JSON.stringify(this.company));

      if (this.company != undefined) {
        if (this.company.Branches.length == 1)
          this.selectBranch(this.company.Branches[0]);

      }
      else {

        var exsistCompany = JSON.parse(sessionStorage.getItem('company')) as any;
        if (exsistCompany != undefined) {
          this.company = exsistCompany;
          this.company = JSON.parse(sessionStorage.getItem('company'));
          this.company.Branches = this.company.Branches.filter(m => m.Active)
        }
      }
    });
  }
  currentUser: any = {};
  userLocationId: any;

  getCurrentUser() {
    this.currentUser = this.user.getCurrentUser((suc) => {
      this.currentUser = suc;
      this.userContext.getRow('GET_USER', this.userLocationId, (res) => {
        this.currentUser.Roles = res.Roles;
        this.currentUser.Settings = res.Settings;
        this.dataTransfer.setUser(this.currentUser)

      }, (res) => { })
    }, (err) => { });
  }

  selectBranch(branch) {

    var company = JSON.parse(sessionStorage.getItem('company')) as any;
    company.UserLocationId = branch.UserLocationId;
    sessionStorage.setItem('company', JSON.stringify(company));
    this.globalSrv.theItem = branch.UserLocationId; // this change will broadcast to every subscriber like below component
    this.branchSelectionAction.emit(true);
    this.branchObj.emit({ branch: branch })
    this.userLocationId = branch.UserLocationId
    this.getCurrentUser()

    if (this.company.Branches.length != 1)
      this.router.navigate(['dashboard'])
  }

  getRoleWithIcon(roleId) {
    var icon = ''
    switch (roleId) {
      case 1:
        icon += `<span class="armx-icon armx-cashier"></span> ${this.translate.instant('common.cashier')}`;
        break;
      case 3:
        icon += `<span class="armx-icon armx-operations"></span> ${this.translate.instant('common.operations')}`;
        break;
      case 2:
        icon += `<span class="armx-icon armx-out-mgr"></span> ${this.translate.instant('common.outletManager')}`;
        break;
    }
    return icon
  }


  ngOnInit() {
    if (this.company == undefined || this.company == null) {
      this.company = JSON.parse(sessionStorage.getItem('company'));
      if (this.company == undefined || this.company == null) {
        this.router.navigate(['/dashboard/outlet-selection']);
      }
      else {
        if (this.company.Branches.length == 1)
          this.selectBranch(this.company.Branches[0]);

      }
    }

    this.navStart.subscribe(evt => {
      this.isBranch = evt.url != '/dashboard/outlet-selection';
    })
  }
}




